var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-box-content",staticStyle:{"display":"flex","flex-direction":"column","align-items":"center","justify-content":"center"}},[_c('img',{staticStyle:{"width":"85%"},attrs:{"src":_vm.item.img}}),_c('span',{staticStyle:{"color":"#ffffff","font-size":"1rem","margin-top":"5%"}},[_vm._v(_vm._s(_vm.item.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }